<template>
<div class="container">

  <div class="min-height:500px">

  </div>
    <section class="section bg-section">
    <div class="bg-1">
    </div>
    <div class="box box2">
      <div class="title2">
        <h2 class="centerspa">SPA</h2>
      </div>
    </div>
    <div class="title1">
      <h1>ΔΡ. ΣΟΦΟΚΛΗΣ ΤΡΑΧΑΝΕΛΛΗΣ ΑΓΓΕΙΟΧΕΙΡΟΥΡΓΟΣ - ΑΓΓΕΙΟΛΟΓΟΣ</h1>
      <h2>Αθήνα - Μυτιλήνη</h2>
      <h3>Η έγκαιρη διάγνωση και θεραπεία βελτιώνει την ποιότητα ζωής των ασθενών και μειώνει τον κίνδυνο μελλοντικών επιπλοκών</h3>
    </div>
   
  </section>
  
</div>
</template>

<script>
"use strict";

const box2 = document.querySelector(".box2");
const box1 = document.querySelector(".sky");
const box3 = document.querySelector(".spa");
const modifiernew = window.innerWidth / 2500;
const modifiernew1 = window.innerWidth / 5000;
const modifiery = window.innerWidth / 7000;
window.addEventListener("scroll", () => {
  const scrollY = 1000 - window.scrollY +870;
  const scrollY2 = window.scrollY;
  const scrollY1 = -scrollY2;
  const scrollY2n = scrollY2 +220;
  const scrollY1n = scrollY1 -480;

  const modifier = window.innerWidth / 870;
  console.log(scrollY * modifier);
  if (scrollY * modifier >= 440) {
      box2.style.clipPath = "circle(100% at 50% " + scrollY * modifier + "px)";
  }
  box1.style.transform = "translateX(" + scrollY2n * modifiery + "px) translateY(" + scrollY1 * modifiernew + "px)";
  box3.style.transform = "translateX(" + scrollY1n * modifiery + "px) translateY(" + scrollY1 * modifiernew1 + "px)";
});

</script>

<style>
html{
  min-height: 5000px;
}
.small{
  height: 700px;
  position: relative;
  background-size:cover ;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  background: url(https://wallpaperaccess.com/full/1493543.jpg);
}
.bg{
  background: url(https://7sky.liqium.com/img/mns3.jpg);
  height: 100%;
  width: 100%;    
  background-size: cover;
  z-index: 50;
  height: 100%;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  z-index: 50;

}
.clip{
  clip-path: circle(75.045% at 50% 85.65%);
}
.img{
  width: 300px;
  height: 300px;
}
.flex{
  display: flex;
  height: 700px;
  justify-content: flex-start;
  align-content: center;
  align-items: flex-end;
}
.flex1{
  display: flex;
  height: 700px;
  justify-content: flex-end;
  align-content: center;
  align-items: center;
}
.small h1{
  color: #fff;
  text-shadow: 5px 5px 10px rgba(48, 48, 48, 0.884);
  font-size: 80px;
  z-index: 9999;
  margin-bottom: 200px;
  margin-left: 100px;
}
    
* {
  margin: 0;
  box-sizing: border-box;
}

html {
  min-height: 200vh;
  font-family: "Roboto", sans-serif;
}
    
.section {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 120vh;
    background: url(https://7sky.liqium.com/img/bgvd3.jpg)
}

.section .box {
    position: absolute;
    width: 100%;
    height: 220%;
    z-index: 10;
}

.section .box.box2 {
    background: url(https://7sky.liqium.com/img/mns3.jpg);
    clip-path: circle(72% at 50% 2900.1px);
}

.section h2 {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    text-align: center;
    color: #fff;
    font-size: 270px;
}
.title1 span{
  width:100% !important;
}
.title1 span{
	-webkit-animation: flip-in-hor-top 1s cubic-bezier(0.250, 0.460, 0.450, 0.940) 1s both;
	animation: flip-in-hor-top 1s cubic-bezier(0.250, 0.460, 0.450, 0.940) 1s both;
}

@-webkit-keyframes flip-in-hor-top {
  0% {
    -webkit-transform: rotateX(-80deg);
            transform: rotateX(-80deg);
    opacity: 0;
  }
  100% {
    -webkit-transform: rotateX(0);
            transform: rotateX(0);
    opacity: 1;
  }
}
@keyframes flip-in-hor-top {
  0% {
    -webkit-transform: rotateX(-80deg);
            transform: rotateX(-80deg);
    opacity: 0;
  }
  100% {
    -webkit-transform: rotateX(0);
            transform: rotateX(0);
    opacity: 1;
  }
}
.title1 {
    position: absolute;
    top: 66%;
    display: flex;
    width: 90%;
}

.title2 {
    position: absolute;
    top: 22% !important;
    width: 100% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
}

.centerspa {
    position: absolute;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    font-family: Gallient !important;
}

.title1 h2,
.title1 h1 {
    position: relative;
    top: 0%;
    transform: translateY(0%);
    font-family: Gallient;
    font-weight: 400;
}
.title1 h2 {
    transform: translateX(-131.657px) translateY(0px);
}
.title1 h1 {
  text-align: left;
  color: #fff;
  font-size: 270px;
  width: 100%;
  transform: translateX(60.3429px) translateY(0px);
}
</style>